module.exports = __webpack_public_path__ + "static/img/矩形 34@2x.f902a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/erpManage/img/矩形 34@2x.png
// module id = BhTt
// module chunks = 10